import React 			from 'react';

import BLComponent		from '../../core/_BLComponent.jsx';

export default class SeriesEmptyResults extends BLComponent {
	constructor (props, context) {
		super(props, context);
	}

	render() {
		return (
			<article className="bdp-series-empty-results">
				<h2 className="bdp-series-empty-results__title">No designs match your criteria</h2>
				<p className="bdp-series-empty-results__body">Try choosing a different voting option or deselecting a category.</p>
			</article>
		);
	}
}